import { useQuery } from "@tanstack/react-query";
import { getBookingsData } from "../index";

const useBookingData = () => {
    return useQuery({
        queryKey: ["bookings-data"],
        queryFn: () => getBookingsData(),
        refetchOnWindowFocus: false,
    });
};

export default useBookingData;
